import { API_BASE_URL } from './client';

export const getModelFams = async (keycloak) => {
  if (!keycloak) {
    console.error('getModelFams: Keycloak instance is undefined');
    return [];
  }
  try {
    if (!keycloak.authenticated) {
      throw new Error('User is not authenticated');
    }
    const response = await fetch(`${API_BASE_URL}/models/ollama/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${keycloak.token}`,
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}, StatusText: ${response.statusText}`);
    }
    const text = await response.text(); // Get raw response text
    let data;
    try {
      data = text ? JSON.parse(text) : []; // Parse as array if text exists, else empty array
    } catch (parseError) {
      console.error('JSON parse error:', parseError);
      return [];
    }
    if (!Array.isArray(data)) {
      console.warn('Response is not an array:', data);
      return [];
    }
    return data;
  } catch (error) {
    console.error('Error in getModelFams:', {
      message: error.message,
      name: error.name,
      stack: error.stack,
    });
    return [];
  }
};
export const getEmbeddingModels = async (keycloak) => {
  if (!keycloak) {
    console.error('getEmbeddingModels: Keycloak instance is undefined');
    return [];
  }
  try {
    if (!keycloak.authenticated) {
      throw new Error('User is not authenticated');
    }
    const response = await fetch(`${API_BASE_URL}/models/embedding/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${keycloak.token}`,
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching embedding models:', error);
    return [];
  }
};

export const registerEmbeddingModel = async (keycloak, name) => {
  if (!keycloak?.authenticated) {
    throw new Error('User is not authenticated');
  }
  const trimmed = (name || '').trim();
  if (!trimmed) {
    throw new Error('Model name is required');
  }
  const response = await fetch(`${API_BASE_URL}/models/embedding/register/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${keycloak.token}`,
    },
    body: JSON.stringify({ name: trimmed }),
  });
  if (!response.ok) {
    const err = await response.text();
    throw new Error(err || `HTTP ${response.status}`);
  }
  return response.json();
};

export const registerOllamaChatModel = async (keycloak, name) => {
  if (!keycloak?.authenticated) {
    throw new Error('User is not authenticated');
  }
  const trimmed = (name || '').trim();
  if (!trimmed) {
    throw new Error('Model name is required');
  }
  const response = await fetch(`${API_BASE_URL}/models/ollama/register/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${keycloak.token}`,
    },
    body: JSON.stringify({ name: trimmed }),
  });
  if (!response.ok) {
    const err = await response.text();
    throw new Error(err || `HTTP ${response.status}`);
  }
  return response.json();
};
